import React from 'react';

// The sheet every file icon is drawn on.
const FileSheet = () => (
  <path
    d="M10 .75h14.49L35.25 11.51V34c0 2.9-2.35 5.25-5.25 5.25H10A5.25 5.25 0 0 1 4.75 34V6c0-2.9 2.35-5.25 5.25-5.25z"
    fill="var(--greyscale-white)"
    stroke="#111"
    strokeWidth="1.5"
  />
);

const Sheet = ({ children }) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <FileSheet />
    {children}
  </svg>
);

/*
Icons say what kind of file this is instead of spelling out the extension, so a docx and
a txt look alike — both are text. Images are not in here, they show a thumbnail instead.
*/
const fileTypeIcons = {
  text: (
    <Sheet>
      <path d="M10 13h20M10 18h20M10 23h20M10 28h11" stroke="#111" strokeWidth="1.5" />
    </Sheet>
  ),
  spreadsheet: (
    <Sheet>
      <rect x="10.75" y="11.75" width="18.5" height="5.5" stroke="#111" strokeWidth="1.5" />
      <rect x="10.75" y="17.25" width="18.5" height="5.5" stroke="#111" strokeWidth="1.5" />
      <rect x="10.75" y="22.75" width="18.5" height="5.5" stroke="#111" strokeWidth="1.5" />
      <line x1="20" y1="11" x2="20" y2="29" stroke="#111" strokeWidth="1.5" />
    </Sheet>
  ),
  pdf: (
    <Sheet>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7513 9.95783C18.3173 9.00287 19.5236 8.71526 20.4613 9.30744C20.9208 9.59783 21.2056 10.031 21.3802 10.4979C21.8453 11.7383 21.7205 13.1998 21.5189 14.4383C21.3097 15.7214 20.8692 16.9542 20.4847 18.1512C21.3909 19.7641 22.5693 21.2523 23.9124 22.5125C25.0246 22.3199 26.1052 22.1972 27.2259 22.1658C27.9117 22.1464 28.5756 22.1761 29.2474 22.2947L29.5365 22.3514L29.5384 22.3524C30.4966 22.5649 31.6285 23.1574 31.6976 24.4266C31.7421 25.2665 31.2309 25.9685 30.5101 26.2772C30.1142 26.447 29.7145 26.517 29.3001 26.5262H29.1068C28.0212 26.4595 26.9918 26.1885 26.014 25.6922C25.0928 25.2357 24.2682 24.6567 23.4896 23.9754C21.3738 24.3888 19.2278 24.9473 17.1771 25.658C16.6271 26.6325 16.1181 27.5968 15.4193 28.5067L15.4183 28.5086C14.7554 29.3595 14.0387 30.1451 13.1693 30.8094L13.1673 30.8113C12.4503 31.3517 11.4327 31.8584 10.4349 31.6531L10.2357 31.6024C9.30223 31.3178 8.7965 30.3582 9.07749 29.411L9.13901 29.2313C9.29798 28.819 9.56639 28.4529 9.8646 28.1375C10.2069 27.7754 10.6049 27.4625 10.9652 27.2059L10.9701 27.202C12.4964 26.1506 14.2154 25.3697 15.9193 24.7059C17.1197 22.5378 18.1847 20.3544 18.9876 18.0018C18.2761 16.5264 17.6406 15.006 17.3851 13.3094L17.3841 13.3016C17.3171 12.7836 17.2662 12.1944 17.3011 11.618C17.3359 11.0435 17.4566 10.4559 17.7513 9.95783ZM15.0404 26.4891C14.3667 26.7888 13.7246 27.1078 13.0873 27.4656C12.6129 27.7319 12.0648 28.064 11.5746 28.4442C11.0801 28.8276 10.6696 29.2412 10.4427 29.6629C10.3411 29.8521 10.3287 30.005 10.388 30.1444C10.4526 30.2953 10.5726 30.3838 10.7455 30.4178C10.9293 30.4537 11.168 30.423 11.4066 30.3152C12.1654 29.9733 12.9119 29.2333 13.5199 28.5125C14.0659 27.865 14.5679 27.2005 15.0404 26.4891ZM27.5765 23.5233C26.8047 23.5227 26.0017 23.5962 25.3216 23.6854C26.4759 24.5006 27.7103 25.0583 29.0814 25.1619C29.4031 25.1825 29.7307 25.1351 29.971 25.0213C30.2027 24.9115 30.3204 24.7609 30.3363 24.5613C30.3497 24.3861 30.2798 24.2149 30.1253 24.0799C29.913 23.8945 29.5712 23.7497 29.1146 23.6551C28.6637 23.5618 28.1333 23.5237 27.5765 23.5233ZM19.8587 19.5057C19.2947 21.0072 18.6506 22.4826 17.93 23.9129C19.38 23.4632 20.8037 23.0877 22.2845 22.7713C21.3564 21.7659 20.5681 20.649 19.8587 19.5057ZM19.516 10.368C19.2955 10.3643 19.0937 10.4682 18.9642 10.6561C18.785 10.9179 18.6804 11.3027 18.6517 11.7889C18.6233 12.2703 18.6715 12.8216 18.7718 13.3895C18.9622 14.4662 19.3325 15.562 19.6585 16.2869C20.0573 14.9182 20.3908 13.3755 20.3451 12.0662L20.3255 11.7518C20.294 11.3839 20.2203 11.0173 20.0785 10.7518C19.945 10.5024 19.7725 10.3722 19.516 10.368Z"
        fill="#111"
      />
    </Sheet>
  ),
  video: (
    <Sheet>
      <path
        d="M25.971 19.0361c.7503.4436.7504 1.5292 0 1.9727l-10.4922 6.2002c-.7638.4512-1.7285-.1001-1.7285-.9873V13.8223c.0001-.8872.9647-1.4377 1.7285-.9864l10.4922 6.2002z"
        stroke="#111"
        strokeWidth="1.5"
      />
    </Sheet>
  ),
  oqio: (
    <Sheet>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6397 14.6482C15.0664 10.9177 19.247 9.05287 22.9776 10.4793C26.7081 11.9059 28.5735 16.0865 27.169 19.8172C26.4667 21.6385 25.0294 23.3284 23.3946 24.7986L21.4962 26.3455C20.8927 26.7954 20.2887 27.2124 19.7071 27.5965C19.8278 28.0024 19.9594 28.3098 20.0362 28.4744H18.3028C16.6898 29.44 15.5157 29.9998 15.5157 29.9998C15.5157 29.9998 15.2746 29.429 14.9454 28.4744H13.2335C13.9029 27.7941 15.9766 25.5008 15.9767 23.3611C15.9767 21.7152 14.6924 20.3549 13.0685 20.2342C12.9039 18.2591 13.0143 16.2832 13.6397 14.6482ZM23.1856 12.7283C22.0666 12.7284 21.0681 13.2219 20.3878 14.0008C19.7075 13.2219 18.709 12.7284 17.5899 12.7283C15.549 12.7283 13.881 14.3854 13.881 16.4373C13.881 18.4892 15.5381 20.1463 17.5899 20.1463C18.1165 20.1462 18.6214 20.0254 19.0821 19.8279L20.3878 21.6053L21.6935 19.8172C22.1433 20.0256 22.659 20.1345 23.1856 20.1346C25.2375 20.1346 26.8945 18.4782 26.8946 16.4373C26.8946 14.3854 25.2376 12.7283 23.1856 12.7283ZM17.589 14.8123C18.4777 14.8013 19.2022 15.5259 19.2022 16.4256C19.2022 17.3144 18.4778 18.0389 17.589 18.0389C16.7004 18.0386 15.9767 17.3142 15.9767 16.4256C15.9767 15.537 16.7004 14.8125 17.589 14.8123ZM23.1856 14.8123C24.0744 14.8013 24.7988 15.5259 24.7989 16.4256C24.7989 17.3144 24.0744 18.0389 23.1856 18.0389C22.2969 18.0388 21.5724 17.3143 21.5724 16.4256C21.5725 15.5369 22.297 14.8124 23.1856 14.8123Z"
        fill="#111"
      />
    </Sheet>
  )
};

/*
Only these can be uploaded, see ALLOWED_FILE_TYPES: pdf everywhere, xlsx and mp4 in the
organization documents. Images get a thumbnail instead of an icon and are not listed here.
Anything else is older data or came in through another channel and falls back to the text sheet.
*/
const ICON_BY_FILE_TYPE = {
  pdf: 'pdf',
  xlsx: 'spreadsheet',
  'vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'spreadsheet',
  mp4: 'video',
  oqio: 'oqio'
};

/**
 * Shows what kind of file this is. Unknown types fall back to the text sheet, so a file
 * always has an icon.
 * @property {string} type - mime subtype or extension, e.g. plain, pdf, xlsx
 */
const FileTypeIcon = ({ type }) => fileTypeIcons[ICON_BY_FILE_TYPE[type?.toLowerCase()] || 'text'];

export default FileTypeIcon;
